import { Route } from '@angular/router';

export const RemitosRoute: Route = {
  path: 'remitos',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/remitos_shell'
    ).then((c) => c.remitosShellRoutes);
  },
};
